const displayTypes = Object.freeze({
  Text: 'text',
  Badge: 'badge',
  Circle: 'circle',
});

export default displayTypes;
